module.exports = __webpack_public_path__ + "static/img/lm386-1.78d358e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/lm386-1.svg
// module id = RqAP
// module chunks = 0